import { render, staticRenderFns } from "./IntentionList.vue?vue&type=template&id=30459b9d&scoped=true&"
import script from "./IntentionList.vue?vue&type=script&lang=js&"
export * from "./IntentionList.vue?vue&type=script&lang=js&"
import style0 from "./IntentionList.vue?vue&type=style&index=0&id=30459b9d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30459b9d",
  null
  
)

export default component.exports